import { observer } from 'mobx-react'

import type { ChangeEvent } from 'react'

import { Select } from '../../Select/Select'
import type { DateFieldFilter } from '../../../models/common/Filters/FilterModel'
import { SvgIcons } from '../../../components/Icon/Icon'
import type { DatePreset } from '../../../models/common/Filters/DateFilterModel'

import { datePresetToSelectOption } from './utils'
import type { TableFilterComponentProps } from './types'

const DateSelect: React.FC<TableFilterComponentProps<DateFieldFilter>> = ({ fieldName, fieldFilter, onFiltersChanged }) => {
  return <Select
  name={fieldName}
  title={fieldName}
  showLabel={false}
  isFilter={true}
  StartIcon={SvgIcons.CalendarSvg}
  options={fieldFilter.datePresetOptions.map(datePresetToSelectOption)}
  selectedOptions={fieldFilter.date_preset === null ? [] : [datePresetToSelectOption(fieldFilter.date_preset)]}
  onChange={({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
    fieldFilter.setDatePreset(value as DatePreset)

    onFiltersChanged?.(value)
  }}
  />
}

export default observer(DateSelect);